<template>
    <v-card outlined rounded="lg">
        <div class="pa-20 pa-md-24">
            <v-row align="center">
                <v-col cols="12" md="" class="mb-10 mb-md-0">
                    <h5 class="page-text--lg font-weight-medium">
                        {{ value?.name || "제목없음" }}
                    </h5>
                </v-col>
                <v-col cols="12" md="auto">
                    <v-row class="row--small">
                        <v-col cols="4" md="auto">
                            <employment-form-view v-bind="{ value }">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="{ ...attrs, loading }" v-on="on" outlined small block color="secondary" class="min-w-md-100px">
                                        <span>미리보기</span>
                                    </v-btn>
                                </template>
                            </employment-form-view>
                        </v-col>
                        <v-col cols="4" md="auto">
                            <employment-form-form v-bind="{ value }" @input="(value) => $emit('input', value)">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="{ ...attrs, loading }" v-on="on" outlined small block color="primary" class="min-w-md-100px">
                                        <span>수정</span>
                                    </v-btn>
                                </template>
                            </employment-form-form>
                        </v-col>
                        <v-col cols="4" md="auto">
                            <v-btn outlined small block color="grey-d" v-bind="{ loading }" @click="$emit('remove', value)">
                                <span class="grey-6--text">삭제</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import EmploymentFormForm from "../employment-form-form.vue";
import EmploymentFormView from '../employment-form-view.vue';

export default {
    components: {
        EmploymentFormForm,
        EmploymentFormView
    },
    props: {
        value: { type: Object, default: () => ({}) }, // meeting
        loading: { type: Boolean, default: false },
    },
};
</script>
